import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';

import PriceParrotService from '~/services/PriceParrotService';

import { controlCentreQueryKeys } from './controlCentreQueryKeys';

export function useTriggerExtranetNotification() {
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: async (propertyId: string) => {
      return await PriceParrotService.triggerExtranetNotification({ propertyId });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: controlCentreQueryKeys.all });
      enqueueSnackbar('Extranet notification triggered successfully', { variant: 'success' });
    },
    onError: (error: Error) => {
      enqueueSnackbar(`Failed to trigger extranet notification: ${error.message || 'Unknown error'}`, {
        variant: 'error',
      });
    },
  });
}
